import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

interface Props {
    filterErrors: readonly string[];
}

export const InvalidFiltersWarning = ({ filterErrors }: Props) => (
    <div className="u-text-center u-mt32" data-testid="emptyWarning">
        <p className="u-t2 u-mb16">Vi kan ikke finne priser på søket ditt</p>
        <p>For å finne overnattingstilbud må du:</p>
        {filterErrors.map((error) => (
            <p className="u-cherry u-strong" key={`error-${error}`}>
                {error}
            </p>
        ))}
        <p>
            <span className="u-hide-gt768">Endre søkealternativene ved å klikke på blyanten på boksen over, eller </span>
            <span className="u-hide-lt768">Endre søkealternativene i filtermenyen til venstre, eller </span>
            <a href={publicRuntimeConfig.basePath}>gå tilbake til forsiden</a>
        </p>
    </div>
);
